export const LANGUAGE_TO_LOCALE: Record<string, string> = {
  cs: 'cs_CZ',
  sk: 'sk_SK',
  en: 'en_US',
  pl: 'pl_PL',
  de: 'de_DE'
};
